import {postToParent} from './messageHandlers'

let lastReportedHeight: number | null = null

export function reportResize(): void {
    const height = getContentHeight()
    if (height === lastReportedHeight) {
        return
    }

    lastReportedHeight = height
    postToParent({type: 'iframe-resize', height})
}

export function resetResizeReporterStateForTests(): void {
    lastReportedHeight = null
}

function getContentHeight(): number {
    const contentBoundsHeight = getBodyContentBoundsHeight()
    const htmlClientHeight = document.documentElement.clientHeight
    const flowHeight = Math.max(
        document.body?.scrollHeight ?? 0,
        document.body?.offsetHeight ?? 0,
        document.documentElement.scrollHeight,
        document.documentElement.offsetHeight
    )

    // Ignore root/body flow metrics when they only mirror the iframe viewport.
    return Math.max(contentBoundsHeight, flowHeight > htmlClientHeight ? flowHeight : 0)
}

function getBodyContentBoundsHeight(): number {
    if (!document.body) {
        return 0
    }

    const range = document.createRange()
    range.selectNodeContents(document.body)
    const rectHeight =
        typeof range.getBoundingClientRect === 'function'
            ? range.getBoundingClientRect().height
            : 0

    return Math.max(
        0,
        Math.ceil(rectHeight)
    )
}
